import React from 'react';
import styled, { css } from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Mixins } from 'planoplan-ui-kit/core/mixins';

export const Button = ({ children, icon, iconStyle, ...props }) => (
  <ButtonView {...props} icon={icon} iconStyle={iconStyle}>
    {children}
    <Icon styleProp={iconStyle}>{icon}</Icon>
  </ButtonView>
);

const Icon = styled.div`
  ${(p) => p.styleProp && p.styleProp.root}
`;

export const buttonCss = css`
  ${Mixins.transition('background-color color')};
  height: ${(p) => (p.height ? p.height : '48px')};
  width: 100%;
  display: flex;
  padding: 0 13px;
  justify-content: ${(p) => (p.icon ? 'space-between' : 'center')};
  align-items: center;
  background-color: ${(p) => (p.background ? p.background : Colors.planoplan_blue)};
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${Colors.white};
  border-radius: 4px;
  border: none;
  cursor: pointer;
  text-decoration: none;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  opacity: ${(p) => (p.isDisabled ? '0.6' : '1')};
  pointer-events: ${(p) => (p.isDisabled ? 'none' : 'all')};

  &:hover {
    background-color: ${(p) => (p.background ? p.background : Colors.electric_blue)};
    color: ${Colors.white};
  }

  ${(p) =>
    p.iconStyle &&
    css`
      &:hover > ${Icon} {
        ${p.iconStyle.hover}
      }
    `}
`;

const ButtonView = styled.button`
  ${buttonCss};
`;
